import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { products } from '../../data/mock';

export const ProductsPreview = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-amber-100 text-amber-700 text-sm font-medium mb-4">
              Our Products
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-navy-900 mb-4">
              Premium Trade Products
            </h2>
            <p className="text-xl text-slate-600 max-w-2xl">
              Quality products sourced from Australia and global markets, 
              ready for international trade.
            </p>
          </div>
          <Link to="/products">
            <Button
              variant="outline"
              size="lg"
              className="border-navy-900 text-navy-900 hover:bg-navy-900 hover:text-white rounded-xl"
            >
              Browse All Products
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>

        {/* Products Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <Card
              key={product.id}
              className="group overflow-hidden border-slate-200 hover:border-teal-300 hover:shadow-xl transition-all duration-300"
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.category}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-900/60 to-transparent" />
                <div className="absolute bottom-4 left-4">
                  <Badge className="bg-teal-600 text-white">
                    {product.origin}
                  </Badge>
                </div>
              </div>

              <CardHeader className="pb-2">
                <CardTitle className="text-lg text-navy-900">
                  {product.category}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-slate-600 mb-4 line-clamp-2">
                  {product.description}
                </p>

                {/* Items Preview */}
                <div className="flex flex-wrap gap-1.5 mb-4">
                  {product.items.slice(0, 3).map((item) => (
                    <span
                      key={item}
                      className="px-2 py-1 bg-slate-100 text-slate-600 text-xs rounded-md"
                    >
                      {item}
                    </span>
                  ))}
                  {product.items.length > 3 && (
                    <span className="px-2 py-1 bg-slate-100 text-slate-500 text-xs rounded-md">
                      +{product.items.length - 3} more
                    </span>
                  )}
                </div>

                {/* Compliance */}
                <div className="flex items-center gap-2 text-xs text-teal-600">
                  <CheckCircle2 className="h-4 w-4" />
                  <span>Trade Ready</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
